export default __webpack_public_path__ + "static/media/bg-wallpaper1.144a5943.jpg";